<template>
  <div>
    <PreparationSlipTemplateViewerGrid
      :items="products"
    ></PreparationSlipTemplateViewerGrid>
  </div>
</template>

<script>
import { api } from "@/api";
import { mapGetters } from "vuex";
import { PreparationSlipTemplateViewerGrid } from "../components";
export default {
  name: "PreparationSlipTemplateViewer",
  components: {
    PreparationSlipTemplateViewerGrid
  },
  props: {
    id: {
      required: true
    }
  },
  created() {
    if (this.id !== null) {
      this.getData();
    }
  },
  computed: {
    ...mapGetters([
      "getInventoryRecords",
      "getInventoryTemplates",
      "getProducts",
      "getIngredients",
      "getRecipes"
    ])
  },
  data() {
    return {
      preparationSlipTemplate: undefined,
      products: []
    };
  },
  methods: {
    async getData() {
      try {
        this.$store.dispatch("slo");
        await this.$store.dispatch("loadAllRecipeStore");
        this.preparationSlipTemplate = await api.retrievePreparationSlipTemplate(
          this.id
        );
        this.products = [
          ...this.preparationSlipTemplate.preparation_slip_template_products
        ].map(x => {
          const originProduct = this.getProducts.find(
            p => p.id === x.fk_product
          );
          return {
            ...originProduct,
            quantity: Number(x.quantity),
            quantity_required: 0,
            quantity_required_recipe: 0
          };
        });
      } finally {
        this.$store.dispatch("elo");
      }
    }
  }
};
</script>

<style></style>
